module.exports={
    "index": {
        "login": "Clasificaciones de miembros",
        "regist": "Regalo para nuevos usuarios",
        "user": "nuevo equipo",
        "jiang": "miembro",
        "set": "Observación",
        "lingqyu": "No se ingresaron comentarios , por favor establezca",
        "liji": "no está ingresado , configúrelo",
        "list": {
            "0": "tiempo de deposito",
            "1": "información de la tarjeta de débito",
            "2": "Nota : Recarga de billetera Bitcoin y billetera USDT. 10% del capital de la recarga de cortesía + tarifa de manejo de USD 20",
            "3": "Lamento no haberlo recibido , continúa comprándolo.",
            "4": "Dólar",
            "5": "El volumen de pedidos del primer día llegó a 20 y no se pueden realizar más pedidos.",
            "6": "Aplique ahora"
        },
        "xuanchaun": {
            "xiazai": {
                "0": "cuenta bancaria",
                "1": "Cancelar el pedido"
            },
            "tianjia": {
                "0": "DIRECCIÓN",
                "1": "No se ingresó ninguna dirección , por favor configúrela"
            },
            "tiqu": {
                "0": "por favor escribe",
                "1": "El saldo de la cuenta es inferior a 200, recargue antes de realizar un pedido."
            }
        },
        "guanyu": {
            "title1": "Por favor verifique el saldo de la cuenta",
            "text1": "Saldo de cuenta disponible insuficiente",
            "title2": "El pedido ha sido procesado , por favor actualiza la página.",
            "text2": "Error de parámetro , confirme el número de pedido."
        },
        "title_content": {
            "0": "El número de pedido no existe",
            "1": "No se pudo tomar el pedido . No hay inventario suficiente en el rango de precios de esta categoría.",
            "2": "Error al capturar el pedido . Inténtelo de nuevo más tarde."
        },
        "content": {
            "0": "Tomar el pedido con éxito",
            "1": "del pedido es insuficiente, realice el pedido nuevamente.",
            "2": "agarrarlo"
        },
        "dugengduo": "Saldo de nivel de membresía insuficiente",
        "darkgrey": {
            "1": {
                "title": "Se ha cancelado la captura de pedidos.",
                "text": "Hora de entrada"
            },
            "2": {
                "title": "obtener sobre rojo",
                "text": "ir a recargar"
            },
            "3": {
                "title": "Mirar de nuevo",
                "text": "El saldo de la cuenta debe ser superior a 200 para desbloquearse."
            },
            "4": {
                "title": "Próximo paso",
                "text": "Código de verificación"
            },
            "5": {
                "title": "por favor ingrese el código de verificación",
                "text": "Error en la verificación del código de verificación gráfica , vuelva a ingresar"
            },
            "6": {
                "title": "Solicitud exitosa",
                "text": "El formato del número de teléfono móvil es incorrecto."
            }
        },
        "into": {
            "yibiaoban": "La cuenta no existe",
            "nihao": "el usuario no existe",
            "yue": "Usuario deshabilitado",
            "shebeigong": "Esta cuenta ya ha iniciado sesión en otro lugar.",
            "riqi": "La contraseña se ha introducido incorrectamente demasiadas veces seguidas.",
            "gaishu": "Vuelve a intentarlo en minutos",
            "kaicaizong": "contraseña incorrecta",
            "xiaoshili": "inicia sesión exitosamente",
            "rili": "El código de verificación no existe",
            "zhouli": "Error del código de verificación",
            "yeli": "Código de verificación no válido",
            "tuilian": "El código de invitación no existe.",
            "hezuo": "El usuario recomendado ha sido desactivado",
            "fukuanxin": "Solicitud incorrecta",
            "tianjiadi": "Por favor ingresa primero",
            "gengxin": "Esta cuenta se ha inhabilitado",
            "yibiaoti": "La función comercial de esta cuenta ha sido congelada.",
            "yaoqing": "Esta cuenta tiene pedidos pendientes y no puede continuar recibiendo pedidos.",
            "yaoqingren": "El saldo es menor que",
            "shijian": "No se puede continuar operando",
            "choujiangci": "Número insuficiente de transacciones para el nivel de membresía",
            "choujianggai": "tesoro de interés",
            "tuijianren": "Retiro anticipado antes del vencimiento , sin ganancias, la tarifa de manejo es",
            "xiejie": "El monto mínimo de inversión mínimo para este producto.",
            "jiriqi": "El monto máximo de inversión para este producto.",
            "dianjifu": "anomalía de datos",
            "tishi": {
                "1": "Saldo disponible insuficiente",
                "2": "Operación exitosa",
                "3": "¡La operación falló ! Por favor verifique el saldo de su cuenta."
            },
            "chongzhijin": "Inversión inicial",
            "chongzhigai": "funcionar",
            "nindeyu": "Transferencia de saldo de intereses",
            "mianchong": "Repetir operación",
            "mianchongci": "Transferir saldo de intereses",
            "chongzhili": {
                "title": "error de parametro",
                "jine": "prohibido desde",
                "shijian": "Realizar la operación actual fuera del período de tiempo.",
                "zhauntai": "La recarga no puede ser inferior a"
            },
            "yijiangli": "La recarga no puede ser mayor que",
            "yiqizhuan": "Error de formato de imagen",
            "jianglili": "El envío falló . Vuelve a intentarlo más tarde.",
            "shezhi": "Pago WeChat",
            "mimashe": "Pagar con Ali-Pay",
            "dangqianmishu": "Retiro de efectivo en WeChat",
            "xinmi": "Retiro de efectivo Alipay",
            "shuxinmi": "Aún no se ha agregado información de la tarjeta bancaria",
            "quemi": "No se ha establecido ninguna contraseña de transacción",
            "shuquemi": "El límite de retiro del nivel de membresía es",
            "dainyou": "Es necesario completar el retiro del nivel actual.",
            "dianyoudi": "pedidos",
            "shudainyou": "Saldo insuficiente",
            "fukuanshe": "El número de retiros a nivel de miembro hoy es insuficiente.",
            "bitedi": "Se requiere el nombre del titular de la cuenta.",
            "shugukuan": "La longitud máxima del nombre del titular de la cuenta es de 30 caracteres.",
            "jisheng": "Se requiere el nombre del banco",
            "qiangou": "Se requiere el número de tarjeta bancaria",
            "xiacixiaoshi": "Se requiere número de teléfono móvil",
            "yingjian": "El número de tarjeta bancaria ya existe",
            "zonggong": "operación fallida",
            "maidian": "La página no existe",
            "yingjiancheng": "Obtener reembolsos",
            "zhuanzhang": "Usuario no registrado",
            "dianfeizong": "Por favor no vuelva a enviar",
            "zhuanzhangti": "conseguir el éxito",
            "zhaunzhangfeiyong": "fallar",
            "zuidifei": "éxito",
            "tikuanjin": "Este nombre y tarjeta bancaria han sido vinculados a otra cuenta.",
            "zuidixian": "No se puede eliminar la dirección de envío predeterminada",
            "bijieshou": "Contraseña de inicio de sesión incorrecta",
            "quezhi": "Iniciado sesión hoy",
            "querenti": "Inicia sesión correctamente y recibe un sobre rojo",
            "yiwen": "Iniciar sesión correctamente",
            "tili": "Todas tus órdenes de retiro",
            "yaohaoyou": "Verificación aprobada",
            "yaohuoci": "Por favor inicia sesión para tomar un pedido",
            "yihanwei": "Error al capturar el pedido . Vuelve a intentarlo más tarde.",
            "gongxihuo": "Error en la captura de pedidos , inventario de productos insuficiente"
        },
        "taocan": {
            "title": "El número de móvil ha sido registrado.",
            "text": "Solo se puede enviar un mensaje de texto en 1 minuto",
            "kuanggong": "Enviado correctamente",
            "liliang": "fallo al enviar",
            "jiage": "SMS enviado satisfactoriamente",
            "yingli": "Parámetros incompletos"
        },
        "baoming": {
            "title": "El espacio del servidor no es compatible . Confirme que admite curl o fsocket . Comuníquese con su proveedor de espacio para resolver el problema o cambiar el espacio.",
            "text": "La cuenta ha caducado"
        }
    },
    "login": {
        "yongdeng": "restricciones de dirección IP",
        "quedeng": "El contenido contiene palabras sensibles.",
        "yonghu": "Anormalidad en los parámetros del producto",
        "mima": "El saldo disponible es insuficiente , recargue primero",
        "xieyi": "la cantidad de hoy",
        "tiaokaun": "Número de usuarios hoy",
        "tongyi": "Número de personas en línea hoy",
        "wangmi": "Año",
        "zhaomi": "luna",
        "zhaomiti": "Iniciar sesión",
        "feihuiyuan": "continuo",
        "lizhi": "Firmó hoy y recibió 1 sobre rojo.",
        "chaunghu": "día",
        "yonghumming": "uno",
        "mimafu": "dos",
        "zhanghaoyou": "cuatro",
        "jinggao": "cinco"
    },
    "botton": {
        "lianjie": {
            "0": "seis",
            "1": "Registrado",
            "2": "Ya has iniciado sesión hoy",
            "3": "trasferencia"
        },
        "zhichi": {
            "0": "transferencia",
            "1": "Centro comercial"
        }
    },
    "content": {
        "zhichu": "uno",
        "jiage": "De segunda categoría",
        "yinliang": "Sin autorización",
        "jiaoyizhe": "Mensaje de configuración",
        "btbjiage": "R",
        "queren": "100",
        "quxiao": "300",
        "shehe": {
            "0": "500",
            "1": "1000",
            "2": "3000"
        }
    },
    "buchong": {
        "caidan": "5000",
        "dengchu": "10000",
        "shangdian": "30000",
        "dan": "Se puede obtener una cuenta en 1 día",
        "choujiang": "comisión de generación",
        "jiangli": "Nivel 1",
        "chongzhi": "Tres generaciones de comisiones",
        "zhuanzhang": "Nivel tres",
        "yongjin": "Subir captura de pantalla de pago",
        "lijikaishi": "Levántate para refrescarte",
        "mianfei": "El siguiente nivel de canal exclusivo puede obtener comisiones más altas.",
        "kaishi": "Tire hacia abajo para reorganizar",
        "lianjie": "Reembolso de comisión subordinada",
        "zhoumo": "No puede estar vacío",
        "shizhi": "Servicio al cliente dedicado",
        "jiaoyi": "Las contraseñas ingresadas dos veces son inconsistentes",
        "zhichi": "Las contraseñas de fondos ingresadas dos veces son inconsistentes",
        "fuzhi": "informacion personal",
        "dangqian": "Para evitar la supervisión de la plataforma, como la coincidencia de pedidos",
        "wanshan": "Por favor confirme la contraseña de la transacción",
        "buyizhi": "mensaje del comprador",
        "ziyou": "aprender",
        "mai": "Comisión de segunda generación",
        "yaoqing": "Nivel 2",
        "yihan": "Código QR",
        "gongxi": "Gestión de contraseñas de transacciones",
        "huifu": "Detalles de la transacción"
    },
    "tanchuang": {
        "one": "Número de pedidos realizados hoy",
        "two": "Ya cobré comisión hoy",
        "title1": "Los resultados de hoy",
        "title2": "Las ganancias de hoy"
    },
    "weishangxian": {
        "weishangxian": "Una vez completada la operación anterior, comuníquese con el servicio de atención al cliente para actualizar la puntuación.",
        "yueshouru": "precio",
        "meiyuan": "Más tareas",
        "qianggouzhong": "salón de misiones",
        "chongzhidizhi": "Reembolso de tareas",
        "jine": "cupón",
        "bufu": "La membresía es válida para siempre",
        "zhengque": "nivel de membresía",
        "xuanxiang": "Detalles del miembro",
        "chongzhi": "Registros de depósitos y retiros de Yu'e Bao",
        "xiaoshi": "Ganancias estimadas de Yu'e Bao",
        "yongjiu": "Transferencia de Yu'e Bao",
        "yongjin": "Transferencia de Yu'e Bao",
        "renshu": "Yu'E Bao",
        "hezuo": "pago del saldo",
        "fenxiang": "Transferencia de saldo",
        "chenggong": "balance",
        "tuijianID": "Hola , para proteger sus derechos e intereses, vincule el número de tarjeta correcto y la información de la sucursal de los cuatro bancos principales (Banco de China, Construcción, Industria y Comercio, Agricultura) si completa la información incorrecta y la cuenta no puede. ser recibido, ¡esta plataforma no asumirá ninguna responsabilidad! Esta plataforma no admite retiros de efectivo de bancos distintos de los cuatro bancos principales.",
        "neirong": "Comisión más",
        "tuijian": "porcentaje de comision"
    },
    "into_one": {
        "yibiaoban": "comisión",
        "nihao": "Guarde el código QR en el código de escaneo local",
        "yue": "Guardado exitosamente",
        "shebeigong": "Guarde capturas de pantalla y escanee el código QR para pagar",
        "riqi": "Anuncio informativo",
        "gaishu": "Modificar nombre",
        "kaicaizong": "cambiar la contraseña",
        "xiaoshili": "Modificado con éxito",
        "rili": "Yuan",
        "zhouli": "Recarga",
        "yeli": "Recargando , actualice el saldo más tarde",
        "tuilian": "Recarga y actualiza",
        "hezuo": "Estado de recarga",
        "fukuanxin": "Actualizar para desbloquear",
        "tianjiadi": "Recargar para desbloquear",
        "gengxin": "Orden de recarga pendiente de pago",
        "yibiaoti": "Registro de recarga",
        "yaoqing": "Instrucciones de recarga",
        "yaoqingren": "Por favor contacte con el servicio de atención al cliente para recargar",
        "shijian": "Monto de recarga",
        "choujiangci": "completar",
        "choujianggai": "Recargar .",
        "tuijianren": "Registro gratis",
        "xiejie": "Estamos trabajando arduamente para obtener pedidos y los resultados se publicarán a continuación.",
        "jiriqi": "todos los productos",
        "dianjifu": "Retirar todo",
        "tishi": {
            "1": "todo",
            "2": "Congelación",
            "3": "Si el envío no se confirma en unos minutos, el sistema congelará el importe del pedido."
        },
        "chongzhijin": "punto",
        "chongzhigai": "borrar",
        "nindeyu": "Hora de llegada : 5 minutos",
        "mianchong": "activos disponibles restantes",
        "mianchongci": "cargando",
        "chongzhili": {
            "title": "actualización exitosa",
            "jine": "ir a subir",
            "shijian": "Ve a tomar un pedido",
            "zhauntai": "Ir a agregar"
        },
        "yijiangli": "Enviar el código de verificación",
        "yiqizhuan": "Cancelar",
        "jianglili": "Saldo disponible",
        "shezhi": "Saldo disponible",
        "mimashe": "tratados",
        "dangqianmishu": "cooperar",
        "xinmi": "nombre",
        "shuxinmi": "Introduzca el estado de tiempo de espera después",
        "quemi": "producto",
        "shuquemi": "Página de inicio del centro comercial",
        "dainyou": "volver a la página de inicio",
        "dianyoudi": "Tamaño del equipo",
        "shudainyou": "Equilibrio del equipo",
        "fukuanshe": "Estado de la comisión del equipo",
        "bitedi": "Comisión total del equipo",
        "shugukuan": "Recarga total del equipo",
        "jisheng": "Retiro total del equipo",
        "qiangou": "Comisión de pedidos de equipo",
        "xiacixiaoshi": "Informes del equipo",
        "yingjian": "flujo de equipo",
        "zonggong": "Gestión de equipos",
        "maidian": "equipo",
        "yingjiancheng": "Abierta en el navegador",
        "zhuanzhang": "Pago en línea",
        "dianfeizong": "área",
        "zhuanzhangti": "Copiado exitosamente",
        "zhaunzhangfeiyong": "Copiar link",
        "zuidifei": "clon",
        "tikuanjin": "cielo",
        "zuidixian": "Configuraciones de avatar",
        "bijieshou": "avatar",
        "quezhi": "Si tiene problemas y necesita ayuda, comuníquese con el servicio de atención al cliente en línea.",
        "querenti": "Nombre",
        "yiwen": "depositar una suma",
        "tili": "El monto del depósito no cumple con los requisitos del sistema.",
        "yaohaoyou": "depósitos",
        "yaohuoci": "historial de acceso",
        "yihanwei": "garantía oficial",
        "gongxihuo": "Proporcionado oficialmente"
    },
    "into_two": {
        "yibiaoban": "Gestión financiera periódica",
        "nihao": "Ciertamente",
        "yue": "Fallo de auditoría",
        "shebeigong": "examen aprobado",
        "riqi": "Servicio al Cliente",
        "gaishu": "Servicio al Cliente",
        "kaicaizong": "red",
        "xiaoshili": "Gestión de contraseñas",
        "rili": "Estimado usuario, para garantizar la seguridad de sus fondos, vincule su nombre real y establezca una contraseña de retiro. Si el nombre no coincide con el nombre de apertura de la cuenta, el retiro no será posible",
        "zhouli": "Se debe completar el punto decimal.",
        "yeli": "horas, el sistema se descongelará automáticamente después de la expiración",
        "tuilian": "Desliza hacia la izquierda o hacia la derecha para ver más",
        "hezuo": "Ha sido enviado",
        "fukuanxin": "terminado",
        "tianjiadi": "Revocado",
        "gengxin": "Por favor introduzca su correo electrónico",
        "yibiaoti": "Ya tienes una cuenta? Ingresa",
        "yaoqing": "Ya tienes una cuenta, descarga ahora",
        "yaoqingren": "venció",
        "shijian": "aprobado",
        "choujiangci": "Despedido",
        "choujianggai": "Comienza tu camino hacia la riqueza",
        "tuijianren": "Titular de la cuenta",
        "xiejie": "Acuerdo de apertura de cuenta",
        "jiriqi": "Nombre de la cuenta",
        "dianjifu": "Dirección de apertura de cuenta",
        "tishi": {
            "1": "banco de apertura de cuenta",
            "2": "banco de deposito",
            "3": "Ingreso del día"
        },
        "chongzhijin": "Pago pendiente",
        "chongzhigai": "Pendiente",
        "nindeyu": "Revisión pendiente",
        "mianchong": "A pagar",
        "mianchongci": "Esperando recibo",
        "chongzhili": {
            "title": "Para ser desbloqueado",
            "jine": "Puede presionar prolongadamente directamente para identificar el código QR en WeChat",
            "shijian": "olvida la contraseña",
            "zhauntai": "Retiro rápido de efectivo"
        },
        "yijiangli": "recarga total",
        "yiqizhuan": "Retiros totales",
        "jianglili": "Los ingresos totales",
        "shezhi": "Los activos totales",
        "mimashe": "Tu balance",
        "dangqianmishu": "Su pedido se realizará el",
        "xinmi": "Su pedido ha sido congelado , espere pacientemente",
        "shuxinmi": "Su pedido ha caducado y no se puede procesar",
        "quemi": "su información de identidad",
        "shuquemi": "Los datos de tu tarjeta bancaria",
        "dainyou": "¿Estás seguro de que deseas eliminar esta dirección?",
        "dianyoudi": "Aún no has agregado información de la tarjeta bancaria",
        "shudainyou": "He aceptado el \"Acuerdo de servicio\"",
        "fukuanshe": "he completado el pago",
        "bitedi": "He entendido y aceptado",
        "shugukuan": "mi balance",
        "jisheng": "mi equipo",
        "qiangou": "mis activos totales",
        "xiacixiaoshi": "mi número de celular",
        "yingjian": "Mi pedido",
        "zonggong": "My bolso",
        "maidian": "mi tarjeta de debito",
        "yingjiancheng": "mío",
        "zhuanzhang": "Captura de pantalla o directamente",
        "dianfeizong": "Banco",
        "zhuanzhangti": "Todos buenos",
        "zhaunzhangfeiyong": "todos los tipos",
        "zuidifei": "El número de teléfono móvil es incorrecto",
        "tikuanjin": "Número de teléfono móvil introducido incorrectamente",
        "zuidixian": "número de teléfono",
        "bijieshou": "Número de teléfono",
        "quezhi": "Teléfono móvil",
        "querenti": "tasa de tramitación",
        "yiwen": "Tomando un pedido",
        "tili": "Tiempo de toma de pedidos",
        "yaohaoyou": "Número de orden",
        "yaohuoci": "Registro de órdenes de captura",
        "yihanwei": "Registro",
        "gongxihuo": "Instrucciones para tomar pedidos"
    },
    "into_s1": {
        "yibiaoban": "tomar un pedido",
        "nihao": "Ordene la cantidad",
        "yue": "Reembolso de comisión por recibir pedidos",
        "shebeigong": "cartel de promoción",
        "riqi": "Número de personas recomendado",
        "gaishu": "Productos Recomendados",
        "kaicaizong": "recomendar",
        "xiaoshili": "sumisión",
        "rili": "Envío exitoso , espere pacientemente la revisión",
        "zhouli": "Envío exitoso , será redirigido pronto",
        "yeli": "Orden de envio",
        "tuilian": "entregar",
        "hezuo": "Número de retiros",
        "fukuanxin": "Estado de retiro",
        "tianjiadi": "Se ha enviado la solicitud de retiro.",
        "gengxin": "Registro de retiros",
        "yibiaoti": "Tasa de retiro",
        "yaoqing": "Cantidad de retiro",
        "yaoqingren": "Retirada Límite",
        "shijian": "retirar",
        "choujiangci": "buscar",
        "choujianggai": "método de pago",
        "tuijianren": "Dirección de sucursal",
        "xiejie": "recipiente",
        "jiriqi": "Tenedor",
        "dianjifu": "estándar de ingresos",
        "tishi": {
            "1": "Tipo de beneficio",
            "2": "Registro de ganancias",
            "3": "Nombre del destinatario"
        },
        "chongzhijin": "Información de la dirección de envío",
        "chongzhigai": "Modificación de dirección de envío",
        "nindeyu": "Edición de dirección de envío",
        "mianchong": "Dirección de envío",
        "mianchongci": "Recibir información de identidad",
        "chongzhili": {
            "title": "Gente nueva",
            "jine": "Nueva contraseña",
            "shijian": "Nuevo número de móvil",
            "zhauntai": "tiempo"
        },
        "yijiangli": "La comisión del equipo de ayer",
        "yiqizhuan": "Ganancias de ayer",
        "jianglili": "Sin datos",
        "shezhi": "Aún no hay registro",
        "mimashe": "Más información",
        "dangqianmishu": "Más",
        "xinmi": "La tarjeta bancaria no está vinculada , ve a vincularla.",
        "shuxinmi": "No se ha introducido ninguna región, configúrala",
        "quemi": "El banco de apertura de la cuenta no está ingresado, configúrelo",
        "shuquemi": "Dirección de sucursal no ingresada, configúrela",
        "dainyou": "No ingresó ningún número de teléfono, configúrelo",
        "dianyoudi": "No ingresó ningún número de teléfono, configúrelo",
        "shudainyou": "No se ingresó ningún nombre real, configúrelo",
        "fukuanshe": "No se ingresó ninguna dirección detallada, configúrela",
        "bitedi": "No se ha introducido ningún número de tarjeta bancaria, configúrelo",
        "shugukuan": "no está ingresado , configúrelo",
        "jisheng": "Estos datos son proporcionados por",
        "qiangou": "La tarifa de gestión se deducirá de este retiro.",
        "xiacixiaoshi": "Cargando",
        "yingjian": "Puede tomar pedidos todos los días.",
        "zonggong": "No hay código QR , haga clic",
        "maidian": "sin datos",
        "yingjiancheng": "No más contenido",
        "zhuanzhang": "No más datos",
        "dianfeizong": "Sin registro",
        "zhuanzhangti": "Hora de registro",
        "zhaunzhangfeiyong": "registro",
        "zuidifei": "Nota: Debido a la gran cantidad de información de recarga, asegúrese de verificar cuidadosamente el número de tarjeta de la cuenta antes de recargar. Esta plataforma cambia de cuenta de vez en cuando. Si tiene alguna pregunta, haga clic en servicio al cliente en línea.",
        "tikuanjin": "centro de actividades",
        "zuidixian": "Número de personas activas",
        "bijieshou": "Nueva dirección de envío",
        "quezhi": "Consejos amables",
        "querenti": "estado",
        "yiwen": "Recarga de usuario",
        "tili": "El nombre de usuario no puede estar vacío",
        "yaohaoyou": "Error al ingresar el nombre de usuario , requiere de 2 a 12 letras o números",
        "yaohuoci": "El usuario toma pedidos",
        "yihanwei": "Baja de usuario",
        "gongxihuo": "número de teléfono"
    },
    "into_f": {
        "yibiaoban": "Contraseña de inicio de sesión",
        "nihao": "Acceso",
        "yue": "Directamente debajo",
        "shebeigong": "Directamente debajo",
        "riqi": "nombre real",
        "gaishu": "Confirmar modificación",
        "kaicaizong": "Confirmar vinculación de tarjeta",
        "xiaoshili": "Seguro",
        "rili": "Confirmar recarga",
        "zhouli": "¿Confirma la cancelación ? La cancelación provocará la congelación del importe.",
        "yeli": "confirmar Contraseña",
        "tuilian": "¿Confirmar para retirar esta cantidad al saldo? ¡No se calcularán intereses sobre retiros indebidos! , y deducir",
        "hezuo": "¿Confirmar para salir?",
        "fukuanxin": "Regresar a mi página en segundos",
        "tianjiadi": "Segundo",
        "gengxin": "Retirarse inmediatamente",
        "yibiaoti": "comprar ahora",
        "yaoqing": "actualizar inmediatamente",
        "yaoqingren": "Configurar ahora",
        "shijian": "Esperando confirmación del comprador",
        "choujiangci": "Esperando confirmación del comprador",
        "choujianggai": "Esperando respuesta del sistema comercial",
        "tuijianren": "filtrar",
        "xiejie": "Introducción",
        "jiriqi": "notificación del sistema",
        "dianjifu": "El sistema se basa en la tecnología LBS y empareja automáticamente los productos a través de la nube.",
        "tishi": {
            "1": "cuenta del sistema",
            "2": "Ingresos acumulados",
            "3": "Recarga en línea"
        },
        "chongzhijin": "Recarga sin conexión",
        "chongzhigai": "Vincular número de teléfono móvil",
        "nindeyu": "vincular tarjeta bancaria",
        "mianchong": "Estadísticas",
        "mianchongci": "Editar dirección de envío",
        "chongzhili": {
            "title": "Editar tarjeta de débito",
            "jine": "editar",
            "shijian": "La red no es estable , por favor intenta nuevamente en un lugar con mejor señal.",
            "zhauntai": "La red es inestable , inténtalo nuevamente en un lugar con mejor señal."
        },
        "yijiangli": "Número de contacto",
        "yiqizhuan": "Ve a tomar un pedido",
        "jianglili": "automático",
        "shezhi": "Cálculo automático",
        "mimashe": "Centro comercial autónomo",
        "dangqianmishu": "a",
        "xinmi": "Obtener código de verificación",
        "shuxinmi": "regla",
        "quemi": "desbloquear",
        "shuquemi": "número de orden",
        "dainyou": "El pedido ha sido congelado y el tiempo de descongelamiento es",
        "dianyoudi": "El pedido ha expirado",
        "shudainyou": "La cantidad total de pedidos.",
        "fukuanshe": "Total del pedido",
        "bitedi": "Se está enviando el pedido",
        "shugukuan": "Pedidos enviados con éxito",
        "jisheng": "detalles del pedido",
        "qiangou": "Orden",
        "xiacixiaoshi": "Recordar contraseña",
        "yingjian": "Establecer como dirección común",
        "zonggong": "Establecer por defecto",
        "maidian": "Establecer avatar",
        "yingjiancheng": "Detalles",
        "zhuanzhang": "DIRECCIÓN",
        "dianfeizong": "Por favor cargue el comprobante de pago",
        "zhuanzhangti": "Por favor sube el bono de recarga",
        "zhaunzhangfeiyong": "Por favor verifique la información de pago cuidadosamente.",
        "zuidifei": "por favor pague",
        "tikuanjin": "Por favor cambia tu nombre",
        "zuidixian": "Asegúrese de mantener el monto de la transferencia en puntos decimales para evitar afectar el tiempo de recarga.",
        "bijieshou": "Por favor transfiera y recargue a la siguiente cuenta",
        "quezhi": "Por favor consulte el servicio de atención al cliente en línea después de completar la recarga.",
        "querenti": "Por favor completa el nombre de la recarga",
        "yiwen": "Por favor rellena el número de teléfono móvil de recarga",
        "tili": "Por favor complete el monto de la recarga",
        "yaohaoyou": "Por favor, ponga su nombre",
        "yaohuoci": "por favor complete el número de teléfono celular",
        "yihanwei": "Por favor introduzca el número de teléfono móvil correcto",
        "gongxihuo": "Por favor complete la dirección detallada"
    },
    "into_s": {
        "yibiaoban": "Por favor complete la dirección de entrega detallada",
        "nihao": "Recuerde su contraseña . Si olvida su contraseña, comuníquese con el servicio de atención al cliente.",
        "yue": "Por favor pregunte al servicio de atención al cliente en línea (la plataforma cambia de cuenta cada cierto tiempo)",
        "shebeigong": "Por favor ingrese la contraseña de la transacción",
        "riqi": "Por favor ingresa el monto de la recarga",
        "gaishu": "Por favor ingrese la contraseña original",
        "kaicaizong": "Por favor, ingrese contraseña",
        "xiaoshili": "Por favor ingrese el nombre del titular de la cuenta",
        "rili": "Por favor ingrese el número de teléfono móvil del titular de la cuenta.",
        "zhouli": "Por favor ingrese la dirección del banco de apertura de la cuenta",
        "yeli": "Por favor ingrese el banco de apertura de cuenta",
        "tuilian": "Por favor ingrese el banco donde está abierta la cuenta",
        "hezuo": "Por favor ingrese su nueva contraseña",
        "fukuanxin": "Por favor ingrese el número de teléfono",
        "tianjiadi": "Por favor ingresa el código de verificación del teléfono móvil",
        "gengxin": "Por favor ingrese el código de referencia",
        "yibiaoti": "Por favor ingrese el monto del retiro",
        "yaoqing": "Por favor ingrese el nombre del destinatario",
        "yaoqingren": "Por favor ingrese una nueva contraseña",
        "shijian": "Por favor introduce tu número de teléfono móvil o dirección de correo electrónico",
        "choujiangci": "por favor ingrese el nombre de usuario",
        "choujianggai": "Por favor ingrese su contraseña de inicio de sesión",
        "tuijianren": "Por favor ingresa el código de verificación por SMS",
        "xiejie": "Por favor ingrese su cuenta /contraseña/código de verificación",
        "jiriqi": "Por favor ingrese la contraseña del fondo",
        "dianjifu": "Por favor ingrese el monto de la transferencia",
        "tishi": {
            "1": "Por favor ingresa el código de invitación",
            "2": "Por favor introduzca el número de tarjeta bancaria",
            "3": "por favor ingrese el código de verificación"
        },
        "chongzhijin": "Por favor seleccione el canal de pago",
        "chongzhigai": "Por favor seleccione el canal de pago",
        "nindeyu": "Por favor seleccione la dirección de entrega",
        "mianchong": "Por favor seleccione el nivel al que desea actualizar",
        "mianchongci": "saldo de la cuenta",
        "chongzhili": {
            "title": "Monto congelado de la cuenta",
            "jine": "Detalles de la cuenta",
            "shijian": "Monto de la cuenta",
            "zhauntai": "Ingresos de la compra"
        },
        "yijiangli": "Compra sin ingresar tu nombre real, configúralo",
        "yiqizhuan": "Al comprar productos financieros , no se calcularán las ganancias por compras maliciosas y se cobrarán tarifas de gestión.",
        "jianglili": "Comprar",
        "shezhi": "Contraseña del fondo",
        "mimashe": "Redireccionando",
        "dangqianmishu": "Para transferir dinero, copie el mensaje y vaya a la banca en línea o Alipay para completar la transferencia y recargar.",
        "xinmi": "Ingrese el monto de la recarga",
        "shuxinmi": "Ingrese su nombre",
        "quemi": "Ingrese el monto del depósito",
        "shuquemi": "ingresar el número de teléfono móvil",
        "dainyou": "Ingrese la contraseña del fondo",
        "dianyoudi": "Regresando",
        "shudainyou": "devolver",
        "fukuanshe": "Aún no se ha agregado ninguna dirección de cosecha",
        "bitedi": "Aún no se ha agregado ninguna tarjeta bancaria",
        "shugukuan": "Entra en la tienda y echa un vistazo.",
        "jisheng": "El host remoto está asignando",
        "qiangou": "desconectar",
        "xiacixiaoshi": "Elige el método de recarga",
        "yingjian": "Elige el método de retiro",
        "zonggong": "Selecciona la cantidad",
        "maidian": "Elige productos financieros",
        "yingjiancheng": "invitar a amigos",
        "zhuanzhang": "Únase para obtener más beneficios",
        "dianfeizong": "Código de invitación",
        "zhuanzhangti": "Enlace de invitación : haga clic para copiar",
        "zhaunzhangfeiyong": "Por favor verifique la información de pago cuidadosamente.",
        "zuidifei": "Retiro de efectivo con tarjeta financiera",
        "tikuanjin": "cuenta de tarjeta de débito",
        "zuidixian": "tarjeta bancaria",
        "bijieshou": "Nombre del banco",
        "quezhi": "pregunta",
        "querenti": "Si necesita ayuda, puede comunicarse con el servicio de atención al cliente para recargar manualmente.",
        "yiwen": "Necesito devolver el dinero",
        "tili": "Ingresos estimados",
        "yaohaoyou": "Rendimiento esperado",
        "yaohuoci": "Número de personas que realizan el primer depósito",
        "yihanwei": "página delantera",
        "gongxihuo": "Recargar ahora"
    },
    "into_se": {
        "yibiaoban": "Código de verificación",
        "nihao": "por defecto",
        "yue": "Tome manualmente una captura de pantalla de la APLICACIÓN y guárdela localmente para escanear el código QR.",
        "shebeigong": "Utilice la aplicación manualmente",
        "riqi": "Hogar",
        "gaishu": "Contraseña de acceso",
        "kaicaizong": "no presentado aún",
        "xiaoshili": "registración exitosa",
        "rili": "Se puede actualizar",
        "zhouli": "No se puede actualizar",
        "yeli": "No se puede actualizar si no se cumplen las condiciones de actualización",
        "tuilian": "Ha alcanzado los criterios de actualización y ha completado la actualización.",
        "hezuo": "notificación del sistema",
        "fukuanxin": "Saldo de usuario insuficiente",
        "tianjiadi": "No hay suficientes usuarios invitados",
        "gengxin": "No se cumplen las condiciones de actualización",
        "yibiaoti": "El saldo de cuenta requerido es mayor que",
        "yaoqing": "invitar",
        "yaoqingren": "para desbloquear",
        "shijian": "dirección de billetera",
        "choujiangci": "Escaneo de billetera disponible para transferencia",
        "choujianggai": "Comisión de equipo hoy",
        "tuijianren": "descarga de la aplicación",
        "xiejie": "Bono de recarga",
        "jiriqi": "Por favor ingrese la dirección TRC20",
        "dianjifu": "Por favor ingrese la dirección ERC20",
        "tishi": {
            "1": "sobre nosotros",
            "2": "agente",
            "3": "regla"
        },
        "chongzhijin": "introducir",
        "chongzhigai": "Calificación",
        "nindeyu": "Sorpresa al abrir la caja regalo",
        "mianchong": "Gana dinero inmediatamente",
        "mianchongci": "Contraseña anterior",
        "chongzhili": {
            "title": "Por favor ingrese la contraseña anterior",
            "jine": "Por favor ingrese la contraseña nuevamente",
            "shijian": "la contraseña ha sido actualizada",
            "zhauntai": "No se pudo cambiar la contraseña"
        },
        "yijiangli": "Por favor marque la casilla para aceptar el acuerdo.",
        "yiqizhuan": "Ha alcanzado los criterios de actualización y ha sido actualizado automáticamente",
        "jianglili": "Rebajado debido a cambio de saldo",
        "shezhi": "notificación del sistema",
        "mimashe": "orden comercial",
        "dangqianmishu": "El sistema ha forzado el pago. Si tiene alguna pregunta, comuníquese con el servicio de atención al cliente.",
        "xinmi": "Activar la captura automática de pedidos",
        "shuxinmi": "Desactivar la captura automática de pedidos",
        "quemi": "Nombre de usuario duplicado",
        "shuquemi": "Rebajado debido a cambio de saldo",
        "dainyou": "Ha alcanzado los criterios de actualización y ha sido actualizado automáticamente",
        "dianyoudi": "Teléfono",
        "shudainyou": "sobre nosotros",
        "fukuanshe": "Ver ahora",
        "bitedi": "plataforma",
        "shugukuan": "anuncio",
        "jisheng": "Invita a tus amigos a ganar dinero",
        "chongxindenglu": "Por favor inicia sesión nuevamente",
        "pingtaijianjie": "Introducción a la plataforma",
        "pingtaijianjie1": "Reglas para tomar pedidos",
        "pingtaijianjie2": "Cooperación de la agencia",
        "pingtaijianjie3": "Cualificaciones de la empresa"
    },
    "qing_sd": "Espere por favor",
    "loading1": "proxy en línea",
    "loading2": "solicitar orden",
    "loading3": "Tomando un pedido",
    "goods": {
        "0": "vidrio verde",
        "1": "Productos exclusivos para el cuidado de la piel.",
        "2": "Vaso de plástico de calidad alimentaria.",
        "3": "perfume clásico",
        "4": "granos de café importados",
        "5": "oso estilo disney"
    },
    "tab_name": {
        "0": "página delantera",
        "1": "Registro de pedido",
        "2": "hacer un pedido",
        "3": "Servicio al Cliente",
        "4": "mío"
    },
    "pingjia": "evaluar",
    "login_t1": "One-stop shop for shopping around the world and earning rebates",
    "zhangh": "Por favor introduce el teléfono móvil",
    "email": "Correo electrónico",
    "use_app": "Usar aplicación",
    "index_t1": "30 % de descuento adicional + 10 % de reembolso en efectivo + envío gratis en la compra de la primera aplicación. Se aplican los términos y condiciones.",
    "qianbao": "billetera",
    "huoqu_yj": "Obtener comisión",
    "zhangh_ye": "Saldo de la cuenta",
    "zhangh_je": "saldo de la cuenta",
    "huoq_yj": "Obtener comisión",
    "dingd_s": "cantidad de pedido",
    "caoz_bz": "Pasos",
    "caoz_t1": "1. Haga clic en el botón Iniciar tarea y siga las indicaciones para completar la tarea.",
    "caoz_t2": "2. Después de completar la tarea, puedes liquidar la comisión al saldo.",
    "kefu_t1": "Si tienes alguna pregunta o necesitas ayuda,",
    "kefu_t2": "Póngase en contacto con el servicio de atención al cliente en línea para resolverlo por usted.",
    "kefu_t3": "Su servicio al cliente dedicado",
    "changj_wtjd": "Preguntas frecuentes",
    "changj_wt": {
        "0": {
            "name": "¿Cómo recargar y qué métodos de pago están disponibles ?",
            "value": "Este sistema está abierto a varios países y los métodos de pago internacionales que ofrecemos incluyen: USDT (ERC20). Al mismo tiempo, también apoyamos las monedas nacionales de diferentes países."
        },
        "1": {
            "name": "¿Cómo puedo invertir y obtener ingresos ?",
            "value": "Puede participar en transacciones de productos básicos en el sistema y obtener ingresos estables por transacciones todos los días. Todos los ingresos se pueden retirar a su tarjeta bancaria."
        },
        "2": {
            "name": "¿Cómo registrarse como miembro ?",
            "value": "Se utiliza un sistema de invitación para registrar nuevos miembros. Para garantizar los ingresos de los miembros registrados y evitar que el registro excesivo reduzca los ingresos, los nuevos miembros solo pueden registrarse bajo invitación de los miembros existentes."
        },
        "3": {
            "name": "¿Existe un límite en el monto de la compra ?",
            "value": "Sí, para brindarles a más miembros la oportunidad de obtener ganancias, cada cuenta en el sistema tiene un límite mínimo de compra."
        }
    },
    "yonghu_m": "nombre de usuario",
    "shoukuan_zh": "Cuentas por cobrar",
    "youxiang": "Correo",
    "zhanghao": "cuenta",
    "xiugai_mima": "cambiar la contraseña",
    "xuanze_yy": "Elige un idioma",
    "queren": "confirmar",
    "bangka": "Por favor vincule la cuenta de pago",
    "xingy_d": "Felicitaciones, tienes un pedido afortunado."
}